// authService.js
import { useJwt } from 'react-jwt';
import axios from 'axios';
import api from './apiService';

const tokenKey = 'token';
const refreshTokenKey = 'refresh_token';

export const getToken = () => {
  return localStorage.getItem(tokenKey);
};

export const getRefreshToken = () => {
  return localStorage.getItem(refreshTokenKey);
};

export const setToken = (token) => {
  localStorage.setItem(tokenKey, token);
};

export const setUserType = (user_type) => {
    localStorage.setItem('user_type', user_type);
  };

  export const setAccountId = (account_id) => {
    localStorage.setItem('account_id', account_id)
  };

export const setRefreshToken = (refreshToken) => {
  localStorage.setItem(refreshTokenKey, refreshToken);
};

export const removeToken = () => {
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(refreshTokenKey);
};

export const TokenExpired = () => {
  const token = getToken();
  const { isExpired } = useJwt(token);
  return isExpired;
};

export const refreshToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    return null;
  }

  try {
    const response = await api.post('/refresh', { refreshToken });
    const { token } = response.data;
    setToken(token);
    return token;
  } catch (error) {
    console.error('Error refreshing token:', error);
    removeToken();
    return null;
  }
};

